module.exports = __webpack_public_path__ + "client/styles/fonts/RobotoMono-Bold.ttf";


//////////////////
// WEBPACK FOOTER
// ./client/styles/fonts/RobotoMono-Bold.ttf
// module id = 1478
// module chunks = 0